// Calendar Embed block schema - Embed Google Calendar
export const calendarEmbedSchema = {
  type: 'calendar-embed',
  label: 'Google Calendar',
  description: 'Embed a Google Calendar',
  icon: 'CalendarDays',
  defaultContent: {
    calendarUrl: '',
    heading: '',
    height: '600',
    showTitle: true,
    showNav: true,
    showTabs: true,
    style: {},
  },
  fields: [
    { name: 'calendarUrl', label: 'Calendar URL', type: 'text', placeholder: 'Paste your Google Calendar sharing URL', required: true },
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'My Schedule' },
  ],
};
